import { requestExtension } from './request-modification.js';
/**
 * Dispatches request processing error.
 *
 * Processes request with the given handler. If processing fails, processes error with the given `onError` one.
 *
 * @typeParam TMeans - Request processing means.
 * @param onError - Error processing handler.
 * @param handler - Request processing handler to process the original request with.
 *
 * @returns New request processing handler.
 */
export function dispatchError(onError, handler) {
    return context => context
        .next(handler)
        .catch(error => context.next(onError, requestExtension({ error })));
}
//# sourceMappingURL=dispatch-error.js.map